import { FullProblemTemplate } from 'src/app/admin/feature/contentViewer/problemTemplatePreview/problemTemplatePreview.component';
import {
  CdkDrag,
  CdkDragDrop,
  CdkDropList,
  CdkDropListGroup,
  DragDrop,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';
import {Component, EventEmitter, Input, Output} from '@angular/core';

interface PreviewAnswer {
  key: string;
  items: string[];
}
@Component({
    selector: 'grouping',
    imports: [CdkDropList, CdkDrag, CdkDropListGroup],
    templateUrl: './grouping.component.html',
    styleUrl: './grouping.component.css'
})
export class GroupingComponent {
  @Input('problem_template') problem_template!: FullProblemTemplate
  @Input('answer') answer?: string = ''
  @Input('viewOnly') viewOnly: boolean = false
  @Output() answerChange = new EventEmitter<string>()
  @Output() onChangeEmitter = new EventEmitter<Function>()

  allItems: string[] = [];
  allGroups: any[] = [];
  previewAnswer: PreviewAnswer[] = [];

  ngOnInit() {
    const details = this.problem_template.details.group ?? this.problem_template.details;

    let parsed: Record<string, string[]> = {};
    if (this.answer) {
      try {
        parsed = JSON.parse(this.answer) as Record<string, string[]>;
      } catch {
        parsed = {};
      }
    }

    const placedItems = new Set<string>();
    this.allGroups = details.allGroups.map(group => {
      const items = parsed[group.value] ?? [];
      items.forEach(item => placedItems.add(item));
      return {
        formatted: group.formatted,
        value: group.value,
        items
      };
    });

    // Anything not already placed in a group (e.g. restoring a saved answer) stays in "All Items".
    this.allItems = details.allItems
      .map(item => item.formatted)
      .filter(item => !placedItems.has(item));

    this.previewAnswer = Object.entries(parsed).map(([key, items]) => ({
      key,
      items
    }));
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }

    this.saveAnswer();
  }

  saveAnswer() {
    const answer: { [key: string]: string[] } = {};
    for (const group of this.allGroups) {
      answer[group.value] = group.items;
    }

    this.answerChange.emit(JSON.stringify(answer));
    this.onChangeEmitter.emit(this.onChangeEmitter);
  }
}